@if (visible()) {
<div class="loader-overlay">
    <div class="loader-content">
        <!-- Ball + Shadow container -->
        <div class="ball-wrapper">
            <div class="ball-shadow"></div>
            <div class="ball">
                <img src="assets/loader.svg" alt="Cargando..." width="100" height="100">
            </div>
        </div>

        <!-- Optional message -->
        @if (message()) {
        <p class="loader-message">{{ message() }}</p>
        }
    </div>
</div>
}